import Vue from 'vue'
import Router from 'vue-router'
// import Login from '@/components/login'
// import CourseDetails from '@/components/course_details'
const Login = r => require.ensure([], () => r(require('@/components/login')), 'Login')
const Home = r => require.ensure([], () => r(require('@/view/home')), 'Home')
const CourseDetails = r => require.ensure([], () => r(require('@/components/course_details')), 'CourseDetails')
const course = r => require.ensure([], () => r(require('@/components/course')), 'course')
Vue.use(Router)
const VideoList = r => require.ensure([], () => r(require('@/components/Video_list')), 'VideoList')
Vue.use(Router)
const testList = r => require.ensure([], () => r(require('@/components/test_list')), 'testList')
const practiceRecords = r => require.ensure([], () => r(require('@/components/practice_records')), 'practiceRecords')
const lessons = r => require.ensure([], () => r(require('@/components/lessons')), 'lessons')
const practice = r => require.ensure([], () => r(require('@/view/practice')), 'practice')
const practiceResult = r => require.ensure([], () => r(require('@/view/practice_result')), 'practiceResult')
const userCenter = r => require.ensure([], () => r(require('@/components/userCenter')), 'userCenter')
const testResults = r => require.ensure([], () => r(require('@/components/testResults')), 'testResults')
const staffList = r => require.ensure([], () => r(require('@/components/staffList')), 'staffList')
const staffData = r => require.ensure([], () => r(require('@/components/staffData')), 'staffData')
const wrongTopic = r => require.ensure([], () => r(require('@/components/wrongTopic')), 'wrongTopic')
const practiceRecordsCharts = r => require.ensure([], () => r(require('@/components/practice_records_charts')), 'practiceRecordsCharts')
Vue.use(Router)

export default new Router({
  routes: [
    
    {
      path:'/',
      name:'home',
      component: Home,
      //这里加一个重定向
      redirect:'course',
      children:[
        {
          path: '/course',
          name: 'course',
          component: course
        },
        {
          path: 'CourseDetails',
          name: 'CourseDetails',
          component: CourseDetails
        },
        {
          path: 'VideoList',
          name: 'VideoList',
          component: VideoList
        },
        {
          path: 'testList',
          name: 'testList',
          component: testList
        },
        {
          path: 'practice',
          name: 'practice',
          component: practice
        },
        {
          path: 'practiceResult',
          name: 'practiceResult',
          component: practiceResult
        },
        {
          path: 'practiceRecords',
          name: 'practiceRecords',
          component: practiceRecords
        },
        {
          path: 'lessons',
          name: 'lessons',
          component: lessons
        },
        {
          path: 'userCenter',
          name: 'userCenter',
          component: userCenter
        },
        {
          path: 'testResults',
          name: 'testResults',
          component: testResults
        },
        {
          path: 'staffList',
          name: 'staffList',
          component: staffList
        },
        {
          path: 'staffData',
          name: 'staffData',
          component: staffData
        },
        {
          path: 'wrongTopic',
          name: 'wrongTopic',
          component: wrongTopic
        },
        {
          path: 'practiceRecordsCharts',
          name: 'practiceRecordsCharts',
          component: practiceRecordsCharts
        },
      ]
      
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js